import ManagementCont from '../../../components/Corporate/Report/ManagementCont'
import React from 'react'
import { Fragment } from 'react'
import { Card } from 'antd'
import { Row } from 'antd'
import { Layout } from 'antd'
import { Breadcrumb } from 'antd'
import { Icon } from 'antd'
import { Tabs } from 'antd'
import PageTitle from '../../../elements/PageTitle'
import Receivable from '../../../components/Corporate/Report/Receivable'
import { get } from 'lodash'
import { withRouter } from 'react-router-dom'
import Payable from '../../../components/Corporate/Report/Payable'
import Orders from '../../../components/Corporate/Report/Orders'
import Sales from '../../../components/Corporate/Report/Sales'

const { Content } = Layout
const { TabPane } = Tabs

function Report(props) {
  return (
    <Fragment>
      <Content style={{ margin: '0px 0px' }}>
        <Card>
          <Row>
            <Breadcrumb>
              <Breadcrumb.Item>Corporate</Breadcrumb.Item>
              <Breadcrumb.Item>Reports</Breadcrumb.Item>
            </Breadcrumb>
            <PageTitle
              title={'Report'}
              subtitle={'Detailed report for different activities throughout the organization. '}
              color={'#633570'}
              iconType={'message'}
            />
          </Row>
        </Card>
        <Row style={{ padding: 10 }}>
          <Card>
            <Tabs
              defaultActiveKey={get(props, 'location.hash') || '#management'}
              onChange={(key) => props.history.push(key)}>
              <TabPane
                tab={
                  <span>
                    <Icon type="info-circle" />
                    Trading Report
                  </span>
                }
                key="#management">
                <ManagementCont />
              </TabPane>
              <TabPane
                tab={
                  <span>
                    <Icon type="info-circle" />
                    Receivable Report
                  </span>
                }
                key="#receivable">
                <Receivable />
              </TabPane>
              <TabPane
                tab={
                  <span>
                    <Icon type="info-circle" />
                    Payable Report
                  </span>
                }
                key="#payable">
                <Payable />
              </TabPane>
              <TabPane
                tab={
                  <span>
                    <Icon type="info-circle" />
                    Sales Report
                  </span>
                }
                key="#sales">
                <Sales />
              </TabPane>
              <TabPane
                tab={
                  <span>
                    <Icon type="info-circle" />
                    Orders
                  </span>
                }
                key="#orders">
                <Orders />
              </TabPane>
            </Tabs>
          </Card>
        </Row>
      </Content>
    </Fragment>
  )
}

Report.propTypes = {}

export default withRouter(Report)
